import type { Review } from '@/types';

export const reviews: Review[] = [
  {
    id: 'r1-1',
    movieId: '1',
    title: '《寄生虫》：垂直空间里的阶层寓言',
    author: '沈砚',
    date: '2024-03-12',
    excerpt: '奉俊昊把整部电影搭成了一座可以上下攀爬的房屋模型，谁住在楼上、谁被困在地下，从第一个镜头就已写好结局。',
    content: [
      '奉俊昊把整部电影搭成了一座可以上下攀爬的房屋模型，谁住在楼上、谁被困在地下，从第一个镜头就已写好结局。半地下室的窗、豪宅的落地窗、暴雨中不断向下流淌的积水，构成了一套完整的空间语法。',
      '真正令人不安的不是穷人与富人的对立，而是两拨底层为了同一块生存空间互相撕咬。影片结尾那场生日宴会，把幽默、暴力与荒诞同时推到了顶点。',
    ],
  },
  {
    id: 'r1-2',
    movieId: '1',
    title: '气味作为阶级的语言',
    author: '林知远',
    date: '2024-04-02',
    excerpt: '在《寄生虫》里，气味是唯一无法伪装的身份标记，也是压垮金家的最后一根稻草。',
    content: [
      '在《寄生虫》里，气味是唯一无法伪装的身份标记，也是压垮金家的最后一根稻草。金钱可以买来西装与谈吐，却买不来身上的味道。',
      '奉俊昊用一个极其具体的感官细节，把抽象的阶级差异钉死在观众的记忆里，这正是他作为类型导演最锋利的地方。',
    ],
  },
  {
    id: 'r2-1',
    movieId: '2',
    title: '《老男孩》：复仇神话的自我瓦解',
    author: '程野',
    date: '2023-11-08',
    excerpt: '朴赞郁让复仇成为一场精心编排的仪式，却在最后一刻把主角连同观众一起拖进道德的地狱。',
    content: [
      '朴赞郁让复仇成为一场精心编排的仪式，却在最后一刻把主角连同观众一起拖进道德的地狱。走廊里那段一镜到底的横版打斗，几乎成了后来所有动作导演的必修课。',
      '影片真正的力量在于，它让「复仇」这个看似正当的动机不断被稀释，直到观众发现，被惩罚的其实是自己观看暴力时的快感。',
    ],
  },
  {
    id: 'r2-2',
    movieId: '2',
    title: '被囚禁的不只是身体',
    author: '苏晚',
    date: '2024-01-19',
    excerpt: '十五年的密室，困住的是吴大修的时间，而真正无处可逃的，是他对真相的执念。',
    content: [
      '十五年的密室，困住的是吴大修的时间，而真正无处可逃的，是他对真相的执念。影片用冷峻的色调与对称构图，把复仇的每一步都拍得像是一场必然的宿命。',
      '当谜底揭开，复仇者与被复仇者的身份彻底颠倒，朴赞郁完成了一次对类型片的优雅背叛。',
    ],
  },
  {
    id: 'r3-1',
    movieId: '3',
    title: '《小姐》：三段叙事与两种凝视',
    author: '沈砚',
    date: '2024-05-21',
    excerpt: '同样的故事被讲了三遍，每一次视角的转移都让权力关系发生翻转。',
    content: [
      '同样的故事被讲了三遍，每一次视角的转移都让权力关系发生翻转。第一部分是骗局的布局，第二部分是真相的倒转，第三部分则是两个女人联手夺回叙述权。',
      '朴赞郁把镜头当作一把手术刀，剖开维多利亚式外表下的欲望与算计，同时让观众反思：谁在观看，谁又在被观看。',
    ],
  },
  {
    id: 'r4-1',
    movieId: '4',
    title: '《燃烧》：一场没有火焰的燃烧',
    author: '林知远',
    date: '2024-02-14',
    excerpt: '李沧东把村上的暧昧与福克纳的怒火揉在一起，拍出了一部关于当代青年愤怒的寓言。',
    content: [
      '李沧东把村上的暧昧与福克纳的怒火揉在一起，拍出了一部关于当代青年愤怒的寓言。惠美的消失既是谜题，也是这个时代对某些人存在的无声抹除。',
      '影片从不给出答案，因为对钟秀而言，最重要的从来不是真相，而是他终于为自己找到了一次行动的理由。',
    ],
  },
  {
    id: 'r5-1',
    movieId: '5',
    title: '《诗》：在疼痛里学习写诗',
    author: '苏晚',
    date: '2023-09-30',
    excerpt: '李沧东没有让美子成为诗人，而是让她成为了一个真正看见世界的人。',
    content: [
      '李沧东没有让美子成为诗人，而是让她成为了一个真正看见世界的人。影片的每一个空镜、每一次沉默，都是在为一句未写出的诗让路。',
      '当美子最终写下那几行字，我们才明白：诗不是逃避苦难的出口，而是直面苦难之后仍愿意凝视的勇气。',
    ],
  },
  {
    id: 'r6-1',
    movieId: '6',
    title: '《杀人回忆》：悬案背后的时代解剖',
    author: '程野',
    date: '2023-12-05',
    excerpt: '奉俊昊把一桩未破的案，拍成了一整个时代的无力感。',
    content: [
      '奉俊昊把一桩未破的案，拍成了一整个时代的无力感。两个警探的方法冲突，正是那个转型期韩国社会内部张力的一次缩影。',
      '结尾处宋康昊凝视镜头的那个眼神，之所以被称为影史最动人的收束之一，是因为它把问题抛回给了银幕外的每一个人。',
    ],
  },
  {
    id: 'r7-1',
    movieId: '7',
    title: '《亲切的金子》：宽恕与审判的距离',
    author: '沈砚',
    date: '2024-01-08',
    excerpt: '朴赞郁用最华丽的色彩，讲了一个关于私刑与群体的古老问题。',
    content: [
      '朴赞郁用最华丽的色彩，讲了一个关于私刑与群体的古老问题。当受害者家属轮流走进那间雪白的房间，复仇已经不是个人的事。',
      '影片在美感与道德之间保持着危险的平衡，让人既沉醉又不安，这正是朴赞郁的标志。',
    ],
  },
  {
    id: 'r8-1',
    movieId: '8',
    title: '《密阳》：信仰之外的那束光',
    author: '苏晚',
    date: '2024-03-27',
    excerpt: '全度妍用近乎失控的表演，演出了一个人信仰崩塌的全部过程。',
    content: [
      '全度妍用近乎失控的表演，演出了一个人信仰崩塌的全部过程。影片没有替申爱下任何判断，只是安静地陪伴她走过最黑暗的那段路。',
      '结尾理发店里的阳光，是李沧东留给观众的一点温柔：生活未必会好起来，但总还有重新开始的可能。',
    ],
  },
  {
    id: 'r9-1',
    movieId: '9',
    title: '《春夏秋冬又一春》：轮回里的四季',
    author: '林知远',
    date: '2023-08-16',
    excerpt: '金基德用一座漂浮的佛寺，搭起了关于欲望与觉悟的完整轨道。',
    content: [
      '金基德用一座漂浮的佛寺，搭起了关于欲望与觉悟的完整轨道。每个季节都是一次人生的缩影，也是下一段轮回的起点。',
      '影片的美学几乎是自洽的：水、门、佛、石，每个意象都在重复中获得了新的意义。',
    ],
  },
  {
    id: 'r10-1',
    movieId: '10',
    title: '《空房间》：沉默如何说爱',
    author: '程野',
    date: '2023-10-11',
    excerpt: '当对白被彻底抽离，影像反而拥有了更强的叙述能力。',
    content: [
      '当对白被彻底抽离，影像反而拥有了更强的叙述能力。金基德让两个几乎没有台词的人，用摆放物件、修好家电的方式互相靠近。',
      '影片提出一个近乎哲思的问题：一个人要多隐形，才能被另一个人真正看见？',
    ],
  },
  {
    id: 'r11-1',
    movieId: '11',
    title: '《醉画仙》：笔墨之外的自由',
    author: '沈砚',
    date: '2023-07-04',
    excerpt: '林权泽拍的不是画家的成功，而是一个天才如何与自己的身世和解。',
    content: [
      '林权泽拍的不是画家的成功，而是一个天才如何与自己的身世和解。张承业的一生，始终在纸墨的短暂自由与现实的困顿之间来回摆荡。',
      '影片的画面本身就像一幅幅水墨，把东方美学的留白发挥到极致。',
    ],
  },
  {
    id: 'r12-1',
    movieId: '12',
    title: '《西便制》：一个民族的声音',
    author: '苏晚',
    date: '2023-06-22',
    excerpt: '潘索里不只是电影的背景音乐，它本身就是这部作品真正的主角。',
    content: [
      '潘索里不只是电影的背景音乐，它本身就是这部作品真正的主角。林权泽用一段颠沛的传承，让传统艺术在银幕上重新被听见。',
      '姐姐的歌声之所以动人，是因为那里面装着一整个时代被压抑的情感。',
    ],
  },
  {
    id: 'r13-1',
    movieId: '13',
    title: '《蔷花，红莲》：创伤如何伪装成鬼',
    author: '林知远',
    date: '2023-11-25',
    excerpt: '这部影片的恐怖，从来不在鬼魂，而在一个家庭不愿面对的伤口。',
    content: [
      '这部影片的恐怖，从来不在鬼魂，而在一个家庭不愿面对的伤口。所有看似超自然的征兆，最终都指向记忆的自我保护机制。',
      '金知云用极为精巧的视听设计，把心理惊悚玩成了一场对观众认知的试探。',
    ],
  },
  {
    id: 'r14-1',
    movieId: '14',
    title: '《追击者》：奔跑在体制的缝隙里',
    author: '程野',
    date: '2024-04-16',
    excerpt: '罗泓轸最残酷的地方在于，他让凶手早早落网，却让营救一次次功亏一篑。',
    content: [
      '罗泓轸最残酷的地方在于，他让凶手早早落网，却让营救一次次功亏一篑。阻碍正义的不是罪犯的狡猾，而是体制的迟钝与冷漠。',
      '影片用一个几乎不喘气的节奏，把观众的焦虑拉到了极限。',
    ],
  },
  {
    id: 'r15-1',
    movieId: '15',
    title: '《大叔》：沉默者的温柔',
    author: '沈砚',
    date: '2024-02-28',
    excerpt: '元斌用极少的台词，演出了一整个关于救赎与羁绊的故事。',
    content: [
      '元斌用极少的台词，演出了一整个关于救赎与羁绊的故事。动作场面干净利落，但真正打动人的，是他与小女孩之间那些安静的瞬间。',
      '影片证明了商业片也可以有真挚的情感内核，这或许正是它成为现象级作品的原因。',
    ],
  },
];